"use client";

import React, { useEffect, useState } from "react";
import { Quote, ShieldCheck } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Robert Henderson",
  quote: "The precision in their landscape design is unmatched. Our custom patio has become the centerpiece of our home, blending perfectly with the natural surroundings.",
  position: "Residential Client"
}, {
  author: "Sarah Montgomery",
  quote: "Campos V transformed our commercial property with their seasonal care and irrigation expertise. Professional, reliable, and truly masters of their craft.",
  position: "Estate Manager"
}];
export default function VoicesOfSecurity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="223164" id="what-our-clients-are-saying" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-[0.03]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668432/img/leaf_pattern_watermark.png" alt="" className="w-[1000px] h-auto object-contain grayscale" />
      </div>

      <div ref={ref} className={cn("container mx-auto px-4 md:px-6 relative z-10 max-w-4xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-6xl font-default font-bold tracking-tight text-primary mb-4">
            What Our Clients Are Saying
          </h2>
          <p className="text-slate-600 text-lg md:text-xl max-w-2xl mx-auto font-sans">
            Discover why homeowners and businesses trust Campos V Landscaping for their most ambitious outdoor projects.
          </p>
        </div>

        <div className="relative bg-card/80 backdrop-blur-sm shadow-xl shadow-shadow-color/10 border border-border/40 rounded-2xl p-8 md:p-16">
          <Carousel setApi={setApi} opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                  <div className="flex flex-col items-center text-center space-y-8">
                    <Quote className="size-16 text-primary/10 rotate-180" />
                    
                    <blockquote className="text-2xl md:text-4xl font-serif italic text-primary leading-relaxed max-w-3xl">
                      "{testimonial.quote}"
                    </blockquote>
                    
                    <div className="flex flex-col items-center space-y-3 pt-4">
                      <div className="space-y-1">
                        <div className="font-default font-semibold text-xl text-foreground">
                          {testimonial.author}
                        </div>
                        <div className="text-sm font-sans text-muted-foreground uppercase tracking-widest">
                          {testimonial.position}
                        </div>
                      </div>
                      
                      <Badge variant="secondary" className="mt-2 text-primary bg-accent hover:bg-accent/80 border-transparent transition-colors rounded-md">
                        <ShieldCheck className="size-3.5 mr-1" />
                        Verified Client
                      </Badge>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex justify-center gap-3 mt-12">
            {Array.from({
            length: count
          }).map((_, i) => <button key={i} data-index={i} className={cn("h-2 rounded-md transition-all duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring", current === i + 1 ? "w-8 bg-primary" : "w-2 bg-primary/20 hover:bg-primary/40")} onClick={() => api?.scrollTo(i)} aria-label={`Go to slide ${i + 1}`} />)}
          </div>
        </div>
      </div>
    </section>;
}